// Fires Google Ads conversion events (AW-16693680351) set up in Google Ads
// under Goals > Contact / Get directions / Submit lead forms.
const AW_ID = "AW-16693680351";

const LABELS = {
  callClick: "g1jACKW65_McEN-xlZg-",
  whatsappClick: "l31ECKi65_McEN-xlZg-",
  enquiryFormSubmitted: "_YNkCL6V6O8cEN-xlZg-",
  getDirections: "NT-5CKu65_McEN-xlZg-",
  catalogueDownload: "7yHVCK665_McEN-xlZg-",
};

// Enhanced conversions: when the visitor has given us their email/phone
// (lead forms), pass it along so Google can match the conversion even when
// its own ad-click cookie is missing. gtag.js hashes this client-side --
// never pre-hash it here. Google Ads flagged "Enquiry form submitted" as
// needing this (Goals > Diagnostics > Enhanced conversions: "Implement
// in-page code in addition to Automatic").
function buildUserData(userData) {
  if (!userData) return undefined;
  const { email, phone } = userData;
  const data = {};
  if (email) data.email = email.trim().toLowerCase();
  if (phone) data.phone_number = phone;
  return Object.keys(data).length ? data : undefined;
}

// Fire-and-forget: use for conversions where the page isn't about to navigate
// away immediately (WhatsApp/Maps links open in a new tab; form submits stay
// on the page).
export function reportConversion(labelKey, userData) {
  const label = LABELS[labelKey];
  if (!label || typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: `${AW_ID}/${label}`,
    value: 1.0,
    currency: "INR",
    user_data: buildUserData(userData),
  });
}

// For same-tab navigations (tel: links): delays the navigation briefly so
// the conversion ping has a chance to send, per Google's recommended pattern.
export function reportConversionAndNavigate(labelKey, url, userData) {
  const label = LABELS[labelKey];
  if (!label || typeof window === "undefined" || typeof window.gtag !== "function") {
    window.location = url;
    return false;
  }
  // The tracker script loads after the page (see public/index.html), so on a very
  // early tap the callback may take a moment. Never leave the visitor waiting on a
  // tel: link: navigate after at most 1.2 s whether or not Google has answered.
  let done = false;
  const go = () => {
    if (done) return;
    done = true;
    window.location = url;
  };
  window.gtag("event", "conversion", {
    send_to: `${AW_ID}/${label}`,
    value: 1.0,
    currency: "INR",
    user_data: buildUserData(userData),
    event_callback: go,
  });
  setTimeout(go, 1200);
  return false;
}
